import { useAxiosPost } from '../hook/useAxios';

const prefix = '/entity-field/';

export const useCreateEntityFieldAPI = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const createEntityFieldAPI = async (data) => {
    return callApi(`${prefix}create`, { ...data });
  };

  return { createEntityFieldAPI, isLoading, isError, isSuccess };
};

export const useGetAllEntityFieldAPI = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const getAllEntityFieldAPI = async (data) => {
    return callApi(`${prefix}get-all`, { ...data });
  };

  return { getAllEntityFieldAPI, isLoading, isError, isSuccess };
};

export const useDeleteEntityFieldAPI = () => {
  // ** custom Hooks **
  const [callApi, { isLoading, isError, isSuccess }] = useAxiosPost();

  const deleteEntityFieldAPI = async (data) => {
    return callApi(`${prefix}delete`, { ...data });
  };

  return { deleteEntityFieldAPI, isLoading, isError, isSuccess };
};
